export const setCurDistributionCalculate = 'SET_CUR_DISTRIBUTION_CALCULATE';